// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"bd407bb9","381":"3cad80c9","787":"073f42bf","984":"0a668ab1"}[chunkId] + ".chunk.js";
};